import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import * as Input from "../../components/Form/Input";
import { Button } from "../../components/Button";
import {
  AuthLayout,
  authCardClass,
  authLinkClass,
  authIconClass,
  authTitleClass,
  authSubtitleClass,
} from "../../components/auth-layout";
import { AuthBrand, AuthMobileLogoShell } from "../../components/auth-brand";
import api from "../../service/api";
import { ArrowLeft, Mail } from "lucide-react";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) {
      toast.error("Informe seu e-mail.");
      return;
    }

    setSending(true);
    try {
      await api.post("/sessions/forgot-password", { email: trimmed });
      toast.success(
        "Se o e-mail estiver cadastrado, você receberá uma senha provisória."
      );
      setEmail("");
    } catch (err: unknown) {
      const msg =
        err &&
          typeof err === "object" &&
          "response" in err &&
          err.response &&
          typeof err.response === "object" &&
          "data" in err.response &&
          err.response.data &&
          typeof err.response.data === "object" &&
          "message" in err.response.data
          ? String((err.response.data as { message: string }).message)
          : "Não foi possível enviar. Tente novamente.";
      toast.error(msg);
    } finally {
      setSending(false);
    }
  }

  return (
    <AuthLayout>
      <AuthMobileLogoShell>
        <AuthBrand className="h-11 w-auto max-w-[min(100%,260px)] object-contain" />
      </AuthMobileLogoShell>
      <div className="mb-8 hidden lg:flex justify-center">
        <AuthBrand className="h-16 w-auto max-w-[min(100%,280px)] object-contain" />
      </div>
      <div className={authCardClass}>


        <div className="mb-6 text-center">
          <h1 className={authTitleClass}>Recuperar senha</h1>
          <p className={authSubtitleClass}>
            Informe o e-mail da sua conta. Se estiver cadastrado, enviaremos uma
            senha provisória. No primeiro acesso você precisará definir uma
            nova senha.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="forgot-email"
              className="mb-1.5 flex items-center gap-2 text-sm font-medium text-zinc-800"
            >
              <Mail className={`h-4 w-4 ${authIconClass}`} />
              E-mail
            </label>
            <Input.Root variant="auth">
              <Input.Control
                id="forgot-email"
                name="email"
                type="email"
                autoComplete="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Input.Root>
          </div>

          <Button
            type="submit"
            variant="brand"
            className="h-11 w-full font-medium"
            disabled={sending}
          >
            {sending ? "Enviando…" : "Enviar senha provisória"}
          </Button>
        </form>

        <Link
          to="/"
          className={`mt-8 flex items-center justify-center gap-2 text-sm ${authLinkClass}`}
        >
          <ArrowLeft className="h-4 w-4 shrink-0" aria-hidden />
          Voltar ao login
        </Link>
      </div>
    </AuthLayout>
  );
}
